import AutoCompleteDropdown from "../../../../../ui library/components/dropdowns/AutoCompleteDropdown";
import HNSColors from "../../../../../ui library/HNSColors";
import { PAYMENTS_MODAL_STYLES } from "../../../../payments/styles/styles";

import AddCustomMedicalItemField from "./AddCustomMedicalItemField";

export default function AddCustomMedicalItemProviderField({
  providerOptions,
  selectedProvider,
  isLoadingProviders,
  onChange,
  onProviderSearch,
}) {
  return (
    <div className="flex w-full gap-4">
      <AddCustomMedicalItemField label="Provider">
        <AutoCompleteDropdown
          data={providerOptions}
          initValue={selectedProvider}
          getOptionLabel={(option) => option?.label || option?.name || ""}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          onValueChange={(_, value) => onChange("providerId", value?.id ?? null)}
          onInputChange={(_, value, reason) => {
            if (reason === "input") {
              onProviderSearch(value);
            }
          }}
          noOptionsText={isLoadingProviders ? "Loading..." : "No Results"}
          disablePortal={false}
          ListboxProps={{
            sx: {
              maxHeight: 200,
              overflow: "auto",
              "&::-webkit-scrollbar": { width: "6px" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: HNSColors.primary[500],
                borderRadius: "3px",
              },
            },
          }}
          textFieldSx={PAYMENTS_MODAL_STYLES.textField}
          dropdownSx={PAYMENTS_MODAL_STYLES.dropdownPaper}
        />
      </AddCustomMedicalItemField>
    </div>
  );
}
